import SelectButton from "@pathwright/ui/src/components/button/SelectButton"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import SelectRole from "@pathwright/features/src/modules/invitation/SelectRole"
import { filterAvailableRoles } from "@pathwright/features/src/modules/invitation/utils"
import { withPathwrightContext } from "@pathwright/features/src/modules/pathwright/PathwrightContext"
import { observer } from "mobx-react"
import pluralize from "pluralize"
import styled from "styled-components"
import inviteStore from "../../store/invite-store"
import "./InviteFormFooter.css"
import InviteFormMessage from "./InviteFormMessage"

const StyledPrompt = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

// huh.
const getIndefiniteArticle = (noun) => {
  return ["a", "e", "i", "o", "u"].indexOf(String(noun)[0]) > -1 ? "an" : "a"
}

const InviteFormFooter = ({ context }) => {
  const { me, school } = context
  const { count, sending, valid } = inviteStore
  const submitButtonProps = {
    brand: true,
    styleType: "primary",
    submitting: sending,
    disabled: !valid
  }
  return (
    <footer className="InviteFormFooter">
      <InviteFormMessage />
      <div className="InviteFormFooter__actions">
        {!sending && (
          <SelectRole
            position="top"
            onChange={inviteStore.action.changeRole}
            value={inviteStore.role}
            roleType={inviteStore.type}
            roleFilter={(type, role) =>
              filterAvailableRoles(
                type,
                role,
                inviteStore.context && inviteStore.context.offering
              )
            }
            prompt={(role) => (
              <StyledPrompt>
                <span>Invite {pluralize("people", count, !!count)} to </span>
                <strong>
                  join as {getIndefiniteArticle(role.label)} {role.label}
                </strong>
              </StyledPrompt>
            )}
          />
        )}
        {me.permissions.can_administrate ? (
          <SelectButton
            {...submitButtonProps}
            options={[
              {
                label: `From you (${me.full_name})`,
                action: () => {
                  inviteStore.action.changeSendFromSchool(false)
                  // letting submit handler handle promise
                  return inviteStore.action.sendInvites()
                },
                selected: !inviteStore.send_from_school
              },
              {
                label: `From ${school.name}`,
                action: () => {
                  inviteStore.action.changeSendFromSchool(true)
                  // letting submit handler handle promise
                  return inviteStore.action.sendInvites()
                },
                selected: inviteStore.send_from_school
              }
            ]}
          >
            Send {pluralize("Invite", count)}
          </SelectButton>
        ) : (
          <SubmitButton
            {...submitButtonProps}
            onSubmit={() => inviteStore.action.sendInvites()}
          >
            Send {pluralize("Invite", count)}
          </SubmitButton>
        )}
      </div>
    </footer>
  )
}

export default withPathwrightContext(observer(InviteFormFooter))
